import {Box, Typography} from '@mui/material';
import DocViewDocListDataGrid from '../../doc-list/DocViewDocListDataGrid';
import './MiniDocList.scss';
import RecentHistory from './recent-history/RecentHistory';
import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import {EditPanelSortType} from './edit-field/EditPanelContainer';
import {t} from 'i18next';
import {usePopoutDimensions} from '../../../PortalPopout';
import {useSignalStore} from '../../../PortalPopout/hooks/useSignalStore';

interface DocListProps {
  width: number;
  height: number;
  panelId: string;
  codingFormUpdated: boolean;
  isPopoutOpen?: boolean;
  refreshKey?: number | string;
  popoutRef?: {
    current: Window | null;
  };
}
const MiniDocList = ({
  panelId,
  width,
  refreshKey,
  codingFormUpdated,
}: DocListProps) => {
  const containerRef = useRef(null);
  const [popoutSize, setPopoutSize] = useSignalStore<{
    width: number;
    height: number;
  }>('miniDocList-popoutSize', {width: 0, height: 0});

  const [miniDocListContainerHeight, setMiniDocListContainerHeight] =
    useSignalStore('miniDocListContainerHeight', 0);

  const REM_PX = 16;
  const popoutState = usePopoutDimensions({
    throttle: 100,
    onResize: ({width, height}) => {
      setPopoutSize({
        width,
        height: height - 2.8 * REM_PX,
      });
    },
  });

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newHeight = entry.contentRect.height;
        setMiniDocListContainerHeight(newHeight);
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);
  const docViewConfiguration = useSelector(
    (state: RootState) => state.docView.docViewConfiguration
  );

  const {allowFullDocList} = useSelector(
    (state: RootState) => state.docView.docViewConfiguration
  );

  return (
    <Box className="mini-doc-list-container" height="100%" width="100%">
      <Box className="mini-doc-list-header" width={'100%'}>
        <Box>
          <Typography data-testid={`mini-doc-list-sort-order`}>
            {EditPanelSortType.optimizedSortOrder ==
            docViewConfiguration.redirectionMode
              ? t('docView.editpanel.optimizedSort')
              : t('docView.editpanel.manualSort')}
          </Typography>
        </Box>
        <Box>
          <RecentHistory panelId={panelId} />
        </Box>
      </Box>
      <Box
        className="mini-doc-list-data-grid"
        width={popoutState.isInPopout ? popoutSize.width : width}
        ref={containerRef}
      >
        <DocViewDocListDataGrid
          panelId={panelId}
          refreshKey={refreshKey}
          miniDocListheight={
            popoutState.isInPopout
              ? popoutSize.height
              : miniDocListContainerHeight
          }
          showFooter={allowFullDocList ? !popoutState.isInPopout : false}
          codingFormUpdated={codingFormUpdated}
        />
      </Box>
    </Box>
  );
};

export default React.memo(MiniDocList);
